/**
 * Utility functions for handling time conversions
 */

/**
 * Function to convert minutes to hours and minutes
 * @param minutes - The number of minutes to convert
 * @returns {Object} - An object containing the hours and minutes
 */
export const minutesToHoursAndMinutes = (
  minutes: number | null
): { hours: number; minutes: number } | null => {
  if (minutes === null) {
    return minutes
  }
  const hours = Math.floor(minutes / 60)
  const minutesLeft = Math.floor(minutes % 60)

  return {
    hours,
    minutes: minutesLeft
  }
}

/**
 * Function to format minutes into a string representation of hours and minutes
 * @param minutes - The number of minutes to format
 * @returns {string} - A formatted string representing hours and minutes or '0 min' if no time is provided
 */
export const formatMinutesToHoursAndMinutes = (minutes: number): string => {
  const parsed = minutesToHoursAndMinutes(minutes)
  if (parsed === null) {
    return '0 min'
  }

  let result = ''
  if (parsed.hours > 0) {
    result += `${parsed.hours}h`
  }
  if (parsed.minutes > 0) {
    if (result) result += ' '
    result += `${parsed.minutes}min`
  }

  return result || '0 min'
}
